import React, { CSSProperties } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Home, ArrowLeft } from "lucide-react";

interface Styles {
  notFound: CSSProperties;
  notFoundContent: CSSProperties;
  errorCode: CSSProperties;
  heading: CSSProperties;
  paragraph: CSSProperties;
  actions: CSSProperties;
  btn: CSSProperties;
}

const styles: Styles = {
  notFound: {
    minHeight: "100vh",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: "20px",
  },
  notFoundContent: {
    textAlign: "center",
    maxWidth: "500px",
  },
  errorCode: {
    fontSize: "120px",
    fontWeight: 900,
    background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
    WebkitBackgroundClip: "text",
    WebkitTextFillColor: "transparent",
    backgroundClip: "text",
    marginBottom: "20px",
    lineHeight: 1,
  },
  heading: {
    marginBottom: "16px",
    color: "#333",
  },
  paragraph: {
    color: "#666",
    marginBottom: "32px",
    fontSize: "18px",
  },
  actions: {
    display: "flex",
    gap: "16px",
    justifyContent: "center",
    flexWrap: "wrap",
  },
  btn: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
  },
};

const NotFound: React.FC = () => {
  const { t } = useTranslation("common");

  return (
    <div style={styles.notFound}>
      <div style={styles.notFoundContent}>
        <div style={styles.errorCode}>404</div>
        <h1 style={styles.heading}>{t("notFound.pageNotFound")}</h1>
        <p style={styles.paragraph}>{t("notFound.pageDoesNotExist")}</p>

        <div style={styles.actions}>
          <Link to="/dashboard" className="btn-primary" style={styles.btn}>
            <Home size={16} /> {t("notFound.goToDashboard")}
          </Link>
          <button
            className="btn-secondary"
            style={styles.btn}
            onClick={() => window.history.back()}
          >
            <ArrowLeft size={16} /> {t("actions.goBack")}
          </button>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
